import * as type from './types';

export function allProjectsData(data) {
    return {
        type: type.GET_ALL_PROJECTS_DATA_REQUESTED,
        data: data,
    }
}